export const errorMessages = {
  emailInvalid: 'email_invalid',
  emailRequired: 'email_required',
  nameRequired: 'name_required',
  nameMin: 'name_min_len',
  nameMax: 'name_max_len',
  nameFullNameRequired: 'name_full_name_required',
  phoneRequired: 'phone_required',
  phoneInvalid: 'phone_invalid',
  phoneNinthDigitRequired: 'phone_ninth_digit_required',
  cpfInvalid: 'cpf_invalid',
  cpfIncomplete: 'cpf_incomplete',
  cpfRequired: 'cpf_required',
  cnpjInvalid: 'cnpj_invalid',
  cnpjIncomplete: 'cnpj_incomplete',
  cnpjRequired: 'cnpj_required',
  passportRequired: 'passport_required',
  creditCardRequired: 'credit_card_required',
  creditCardInvalid: 'credit_card_invalid',
  cardHolderRequired: 'card_holder_required',
  expirationDateInvalid: 'exp_date_invalid',
  expirationDateRequired: 'exp_date_required',
  expirationDateExpired: 'exp_date_expired',
  cvvInvalid: 'cvv_invalid',
  cvvInvalidAmex: 'cvv_invalid_amex',
  cvvRequired: 'cvv_required',
  cepRequired: 'postal_code_required',
  cepInvalid: 'postal_code_invalid',
  streetRequired: 'street_required',
  streetMaxLength: 'street_max_length',
  numberRequired: 'number_required',
  districtRequired: 'district_required',
  districtMaxLength: 'district_max_length',
  cityRequired: 'city_required' ,
  stateRequired: 'state_required',
  installmentsRequired: 'installments_required',
  recurrenceAcceptanceRequired: 'recurrence.acceptance.disclaimer.requiredField',
};
